import { render, staticRenderFns } from "./CollectionsFilter.vue?vue&type=template&id=3d67dc78&lang=pug"
import script from "./CollectionsFilter.vue?vue&type=script&lang=js"
export * from "./CollectionsFilter.vue?vue&type=script&lang=js"
import style0 from "./CollectionsFilter.vue?vue&type=style&index=0&id=3d67dc78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports